export let life = {
  async created () {
    await this.methods('getOnSiteEvidence')
    this.activeName = 'credentials'
  }
}
export let event = {
  handleSelect (selections) {
    this.methods('setSelections', selections)
  },
  // 上传
  handleClickUpload (name) {
    this.methods('openFilesChoose', name)
  },
  // file 选择了
  fileChange (ev) {
    this.methods('choosedFiles', ev)
  },
  uploadStart () {
    this.methods('uploadStart')
  },
  // 下载
  handleClickDownLoad (name) {
    this.methods('downloadFiles', name)
  },
  // 删除
  handleClickDelete (name) {
    this.methods('deleteFiles', name)
  },
  // 确定处理
  handleClickDeal () {
    this.methods('dealBlackSubmit')
  }
}
export let watch = {
  data () {
    console.log(this.data, this, 'watch')
  }
}
